module.exports = __webpack_public_path__ + "assets/img/img1.b2bb26b5.png";